module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"header":"Provide data of your website or social media profile","description":"Super! Affiliation is a great choice. Now let us know where you will use our tools - add your social media profile or website (blog, service)."}}')
  delete Component.options._Ctor
}
